import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  runTransaction,
  Timestamp,
  setDoc,
  addDoc
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase config שלך
const firebaseConfig = {
  apiKey: "AIzaSyCOe_qzd83E7Fyahlfj4KXfEVJav2kdur0",
  authDomain: "yakov-7798e.firebaseapp.com",
  projectId: "yakov-7798e",
  storageBucket: "yakov-7798e.firebasestorage.app",
  messagingSenderId: "367925648333",
  appId: "1:367925648333:web:b39089564bff3931ca4284",
  measurementId: "G-E1D7SW8566"
};

const app = initializeApp(firebaseConfig);

// Configure Firestore with better settings
export const db = getFirestore(app);

// Configure Storage
export const storage = getStorage(app);

// Enable offline persistence
if (typeof window !== 'undefined') {
    try {
        // Enable offline persistence for better performance
        console.log("Firebase initialized with offline persistence");
    } catch (error) {
        console.warn("Could not enable offline persistence:", error);
    }
}

// Configure Firebase timeout settings
const firestoreSettings = {
    cacheSizeBytes: 100 * 1024 * 1024, // 100MB cache (increased)
    experimentalForceLongPolling: true, // Use long polling for better connection stability
    useFetchStreams: false, // Disable fetch streams to prevent timeout issues
    ignoreUndefinedProperties: true // Ignore undefined properties to reduce data size
};

// Apply settings to Firestore
if (typeof window !== 'undefined') {
    // Only apply settings in browser environment
    try {
        // Note: These settings might need to be applied differently depending on Firebase version
        console.log("Firebase initialized with timeout-friendly settings");
        
        // Add timeout configuration for better connection stability
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
    // Add timeout to fetch requests
    const timeout = 120000; // 120 seconds timeout (increased further)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    
    return originalFetch(url, {
        ...options,
        signal: controller.signal
    }).finally(() => {
        clearTimeout(timeoutId);
    });
};

// Add global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', function(event) {
    console.error('Unhandled promise rejection:', event.reason);
    // Prevent the default browser behavior
    event.preventDefault();
});

// Add global error handler for errors
window.addEventListener('error', function(event) {
    console.error('Global error:', event.error);
    // Prevent the default browser behavior for some errors
    if (event.error && event.error.message && (
        event.error.message.includes('timeout') || 
        event.error.message.includes('network') ||
        event.error.message.includes('connection')
    )) {
        event.preventDefault();
    }
});

// Add performance monitoring
window.addEventListener('load', function() {
    // Log performance metrics
    if (window.performance && window.performance.timing) {
        const loadTime = window.performance.timing.loadEventEnd - window.performance.timing.navigationStart;
        console.log('Page load time:', loadTime + 'ms');
    }
});
    } catch (error) {
        console.warn("Could not apply Firebase timeout settings:", error);
    }
}

// ✅ יצירת הזמנה עם מספר תור
export const addOrder = async (userId, orderData) => {
  const counterRef = doc(db, "users", userId, "queue", "last");

  try {
    const newQueueNumber = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      let nextQueueNumber = 1;

      if (counterDoc.exists() && typeof counterDoc.data().value === "number") {
        nextQueueNumber = counterDoc.data().value + 1;
      } else {
        transaction.set(counterRef, { value: 1 });
      }

      const newOrderRef = doc(collection(db, "users", userId, "orders"));
      const finalOrderData = {
        ...orderData,
        queueNumber: nextQueueNumber,
        timestamp: Timestamp.now(),
        status: orderData.paymentMethod === "מזומן בקופה" ? "ממתין לתשלום" : "שולם, ממתין להכנה",
        done: false
      };

      transaction.set(newOrderRef, finalOrderData);
      transaction.update(counterRef, { value: nextQueueNumber });

      return nextQueueNumber;
    });

    return newQueueNumber;
  } catch (error) {
    console.error("שגיאה בהוספת הזמנה:", error);
    throw new Error("נכשל בהוספת הזמנה.");
  }
};

// ✅ העברת הזמנה להיסטוריה
export const archiveOrder = async (userId, order) => {
  try {
    const historyRef = doc(db, "users", userId, "orderHistory", order.id);
    const archivedOrderData = {
      ...order,
      completedAt: Timestamp.now(),
      status: "בוצעה"
    };
    await setDoc(historyRef, archivedOrderData);
  } catch (error) {
    console.error("שגיאה בארכוב הזמנה:", error);
    throw error;
  }
};

// ✅ איפוס מספר תור
export const resetQueue = async (userId) => {
  const counterRef = doc(db, "users", userId, "queue", "last");
  try {
    await setDoc(counterRef, { value: 0 });
  } catch (error) {
    console.error("שגיאה באיפוס התור:", error);
    throw error;
  }
};

// ✅ איפוס סירים
export const resetPots = async (userId) => {
  const MAX_POT_CAPACITY_LITERS = 40;
  const mehfoodPotRef = doc(db, "users", userId, "pots", "mehfood");
  const sheeritPotRef = doc(db, "users", userId, "pots", "sheeritYisrael");

  try {
    await Promise.all([
      setDoc(mehfoodPotRef, { currentLevelLiters: MAX_POT_CAPACITY_LITERS }),
      setDoc(sheeritPotRef, { currentLevelLiters: MAX_POT_CAPACITY_LITERS })
    ]);
    console.log("הסירים אופסו בהצלחה.");
  } catch (error) {
    console.error("שגיאה באיפוס סירים:", error);
    throw error;
  }
};
